import { initStripePayment } from './stripe';
import { initRazorpayPayment } from './razorpay';
import { initAuthorizenetPayment } from './authorizenet';
import { loadScriptAsync } from './scriptLoader';

const RAZORPAY_JS_URL = `https://checkout.razorpay.com/v1/checkout.js`;
const STRIPE_JS_URL = `https://js.stripe.com/v3/`;
const AUTHORIZE_SANDBOX_JS_URL = `https://jstest.authorize.net/v1/Accept.js`;
const AUTHORIZE_PROD_JS_URL = `https://js.authorize.net/v1/Accept.js`;

export const initSTPayment = async (checkoutId, apiUrl, apiKey, callbackFunc, useAuthNetSandbox = false) => {
    if (!checkoutId || !apiUrl || !apiKey || !callbackFunc) {
        callbackFunc({ status: 'failed', message: 'Error while initiating payment' });
        return;
    }

    const response = await fetch(`${apiUrl}/checkout/${checkoutId}/payment`, {
        method: 'POST',
        headers: new Headers({
            "Content-Type": 'application/json',
            "X-Shoptype-Api-Key": apiKey
        }),
        body: {}
    });

    const paymentDetails = await response.json();

    switch (paymentDetails.method) {

        case 'razorpay':
            await loadScriptAsync(paymentDetails.method, RAZORPAY_JS_URL);
            await initRazorpayPayment(paymentDetails, checkoutId, callbackFunc);
            break;

        case 'stripe':
            await loadScriptAsync(paymentDetails.method, STRIPE_JS_URL);
            await initStripePayment(paymentDetails, callbackFunc);
            break;

        case 'authorize':
            if (useAuthNetSandbox) {
                //pass useAuthNetSandbox as true to use AcceptJs sandbox Js
                await loadScriptAsync(paymentDetails.method, AUTHORIZE_SANDBOX_JS_URL);
            } else {
                await loadScriptAsync(paymentDetails.method, AUTHORIZE_PROD_JS_URL)
            }

            await initAuthorizenetPayment(paymentDetails, checkoutId, apiKey, apiUrl, callbackFunc);
            break;

        default:
            callbackFunc({ status: 'failed', message: 'Error while initiating payment' });
    }
}

window.initSTPayment = initSTPayment;